import React, { useContext, useEffect, useState } from "react";

import Movepoint from "components/Movepoint/Movepoint.js";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { pink, green, orange } from "@material-ui/core/colors";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";

import iconCertification from "../../img/icon_certification.png";

// import Avatar from "./Avatar.js";

import { AppContext } from "../../AppContext";
import AuthService from "../../AuthService";

const styles = {
  formControl: {
    margin: "5px",
    width: "180px",
  },
  imageToggle: {
    display: "none",
    "&:checked ~ $avatar": {
      objectFit: "cover",
    },
    "&:checked ~ $banner": {
      objectFit: "cover",
    },
  },
  imageLabel: {
    display: "block",
    height: "100%",
    width: "100%",
    cursor: "pointer",
  },
  avatar: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  },
  banner: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  },
  infoButton: {
    background: "skyblue",
    color: "#fff",
    marginTop: "10px",
    marginRight: "10px",
    height: "30px",
  },
  successButton: {
    color: "#fff",
    marginTop: "10px",
    marginRight: "10px",
    background: green[500],
  },
  warningButton: {
    color: "#FFF",
    marginTop: "10px",
    marginRight: "10px",
    background: orange[500],
  },
  dangerButton: {
    color: "#fff",
    marginTop: "10px",
    marginRight: "10px",
    background: pink[500],
  },
  paper: {
    position: "relative",
    width: "100%",
    height: "350px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    "@media (max-width: 960px)": {
      height: "250px",
    },
    "@media (max-width: 600px)": {
      flexDirection: "column",
      height: "auto",
    },
  },
  avatarContainer: {
    position: "relative",
    width: "350px",
    height: "350px",
    flexShrink: 0,
    overflow: "hidden",
    "@media (max-width: 960px)": {
      width: "250px",
      height: "250px",
    },
    "@media (max-width: 600px)": {
      width: "100%",
      height: "250px",
    },
  },
  avatarContainerFullWidth: {
    width: "100% !important",
    "@media (max-width: 960px)": {
      width: "100% !important",
    },
    "@media (max-width: 600px)": {
      width: "100% !important",
    },
  },
  bannerContainer: {
    width: "calc(100% - 350px)",
    height: "350px",
    flexShrink: 0,
    overflow: "hidden",
    "@media (max-width: 960px)": {
      width: "calc(100% - 250px)",
      height: "250px",
    },
    "@media (max-width: 600px)": {
      width: "100%",
      height: "200px",
    },
  },
  iconCertification: {
    position: "absolute",
    top: "5px",
    left: "5px",
    height: "35px",
  },
};

const useStyles = makeStyles(styles);

export default function List(props) {
  const classes = useStyles();
  const context = useContext(AppContext);

  const authService = new AuthService();
  const nbItemsToFetch = 12;

  const [toggle, setToggle] = useState(false);
  const [items, setItems] = useState([]);
  const [itemsLoaded, setItemsLoaded] = useState(false);

  const { verified } = props;

  useEffect(() => {
    loadItems(0, nbItemsToFetch);
  }, []);

  const loadItems = (start, end) => {
    authService.setUrl(
      context.apiUrl + context.usersHonoPath + "profilPicture"
    );
    authService.request(
      "get",
      {
        start,
        end,
        verified: verified ? verified : false,
      },
      (response) => {
        setItems(items.concat(response.data));
        setItemsLoaded(true);
      }
    );
  };

  const showMore = () => {
    if (itemsLoaded) {
      let start = items.length;
      let end = start + nbItemsToFetch;
      loadItems(start, end);
    }
  };

  const handleResponse = (picture, status) => {
    clearItem(picture);
    authService.setUrl(
      context.apiUrl + context.usersHonoPath + "profilPicture/verified"
    );
    authService.request(
      "put",
      {
        userId: picture.userId,
        status,
      },
      () => {}
    );
  };

  const clearItem = (item) => {
    let index = items.map((e) => e._id).indexOf(item._id);
    items.splice(index, 1);
    setItems(items);
    setToggle(!toggle);
  };

  const ToggleableImage = ({ src, alt, imageClass }) => (
    <label className={classes.imageLabel}>
      <input type="checkbox" className={classes.imageToggle} />
      <img className={imageClass} src={src} alt={alt} />
    </label>
  );

  return (
    <>
      <Grid container xs={12} spacing={3}>
        {items.map((picture) => (
          <Grid key={picture.userId} item lg={12} md={12} xs={12}>
            <>
              <Paper className={classes.paper}>
                {picture.normal && (
                  <div
                    className={`${classes.avatarContainer} ${
                      !picture.banner ? classes.avatarContainerFullWidth : ""
                    }`}
                  >
                    {picture.userVerified && (
                      <img
                        className={classes.iconCertification}
                        src={iconCertification}
                      />
                    )}
                    <ToggleableImage
                      src={picture.normal}
                      alt="avatar"
                      imageClass={classes.avatar}
                    />
                  </div>
                )}
                {picture.banner && (
                  <div
                    className={`${classes.bannerContainer} ${
                      !picture.normal ? classes.avatarContainerFullWidth : ""
                    }`}
                  >
                    <ToggleableImage
                      src={picture.banner}
                      alt="banner"
                      imageClass={classes.banner}
                    />
                  </div>
                )}
              </Paper>

              <p>
                <b>{picture.userName}</b>
              </p>
              <p>
                Unsafe coefficient :{" "}
                {picture.unsafeCoefficient
                  ? Math.round(picture.unsafeCoefficient * 100)
                  : " UNK "}
              </p>

              <Box p={0} display="flex" flexDirection="column">
                {!verified && (
                  <Button
                    className={classes.successButton}
                    onClick={() => handleResponse(picture, "approved")}
                    variant="contained"
                  >
                    Accept
                  </Button>
                )}

                {!verified && (
                  <Button
                    className={classes.warningButton}
                    onClick={() => handleResponse(picture, "nudity")}
                    variant="contained"
                  >
                    Nudity
                  </Button>
                )}

                <Button
                  className={classes.dangerButton}
                  onClick={() => handleResponse(picture, "refused")}
                  variant="contained"
                >
                  Refuse
                </Button>
              </Box>
            </>
          </Grid>
        ))}
      </Grid>

      <Movepoint onEnter={showMore} />
    </>
  );
}
